import React from 'react'
import Link from 'next/link'

export function Brand (props) {
  return (
    <Link href='/'>
      <a className='navbar-brand' title='Go to the Business Tax Portal homepage'>
        <img src='/static/img/logo.svg' alt='Business Tax Portal' aria-hidden='true'/>
        <span>Business Tax Portal</span>
      </a>
    </Link>
  )
}
